import { getAuth, onAuthStateChanged, User } from 'firebase/auth';

export const getAuthenticatedToken = async (forceRefresh = false): Promise<string> => {
  const auth = getAuth();
  let user = auth.currentUser;

  if (!user) {
    user = await new Promise<User>((resolve, reject) => {
      const unsubscribe = onAuthStateChanged(
        auth,
        (u) => {
          unsubscribe();
          if (u) resolve(u);
          else reject(new Error('User is not authenticated'));
        },
        (err) => {
          unsubscribe();
          reject(err);
        },
      );
    });
  }

  try {
    return await user.getIdToken(forceRefresh);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    throw new Error('Failed to retrieve ID token: ' + err.message);
  }
};
